module.exports = __webpack_public_path__ + "static/img/M-5.c3f5b4e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/art/M-5.png
// module id = sF4S
// module chunks = 0